import React from "react";
import PropTypes from "prop-types";
import { Box, Button, DialogActions, DialogContent, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import PrintIcon from '@material-ui/icons/Print'
import { GsdActualBarChart, OperationTimeBarChart, OperationTimeSummeryBarChart, PcsLineChart } from "../index";
import reportsCommonStyles from '../StudyBrowserReports.module.scss'
import styles from './PotentialStudyReport.module.scss'
import { utilFunctions } from '../../../../_helpers'

import {
    videoModeOnGray,
    videoModeOnColor,
    videoModeOffGray,
    videoModeOffColor,
    singleOperationOn,
    singleOperationOff,
    multipleOperationOn,
    multipleOperationOff
} from "../../../../asset";

const PotentialStudyReportTab = (props) => {
    return (
        <React.Fragment>
            <Grid container>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.summaryInfoContainer}>
                    <Grid
                        container
                        item
                        xs={6}
                        sm={6}
                        direction="column"
                        alignItems="flex-start"
                        justify="center"
                        className={reportsCommonStyles.summaryInfoGroup}
                    >
                        <Typography>Total Elapsed Time</Typography>
                        <div>{props.data.totalElapsedTime.min}<sub>MIN</sub> {props.data.totalElapsedTime.sec}<sub>SEC</sub></div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={6}
                        sm={6}
                        direction="column"
                        alignItems="flex-start"
                        justify="center"
                        className={reportsCommonStyles.summaryInfoGroup}
                    >
                        <Typography>Total Study PCS</Typography>
                        <div>{props.data.operation.studyPcs.length}<sub>PCS</sub></div>
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.infoContainer}>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>EPF</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.epf}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>VIDEO MODE</Grid>
                        <Grid item xs={8} className="uppercase bold">
                            {!props.data.isVideoOn ?
                                <img src={videoModeOffColor} /> :
                                <img src={videoModeOffGray} />}
                            {props.data.isVideoOn ?
                                <img src={videoModeOnColor} /> :
                                <img src={videoModeOnGray} />}
                        </Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>TM NAME</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.teamMemberName}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>OPERATION MODE</Grid>
                        <Grid item xs={8} className="uppercase bold">
                            {!props.data.isMultiple ?
                                <img src={singleOperationOn} /> :
                                <img src={singleOperationOff} />}
                            {props.data.isMultiple ?
                                <img src={multipleOperationOn} /> :
                                <img src={multipleOperationOff} />}
                        </Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>CREATED AT</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.createdAt}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>OPERATION</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.operation.name}</Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={styles.border}>
                    <Grid item xs={4} sm={4} className={styles.topMarginFix}>
                        <GsdActualBarChart gsd={props.data.operation.gsd} actual={props.data.operation.actual} width='100%' height={220} />
                    </Grid>
                    <Grid item xs={8} sm={8}>
                        <span className={styles.isActualCyclesInfo}>{props.data.operation.isActualCycles.length}/{props.data.operation.studyPcs.length} <sub>LR</sub></span>
                        <OperationTimeBarChart data={props.data.operation.operationTimesChart || {}} width='100%' height={220} />
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={6} lg={6}>
                    <Grid container item xs={9} className={styles.border}>
                        <Grid container item xs={12}>
                            <Grid item xs={6} className={styles.infoGroup}>
                                {props.data.operation.pcs} <sub>PCS</sub>
                            </Grid>
                            <Grid item xs={6} className={styles.infoGroup}>
                                {utilFunctions.formatCycleTimes(props.data.operation.avgCT)} <sub>AVG</sub>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <PcsLineChart data={props.data.operation.pcsLineChart || {}} width='100%' height={200} />
                        </Grid>
                    </Grid>
                    <Grid container item xs={3}>
                        <Grid item xs={12} className={reportsCommonStyles.dataContainer} >
                            <label>Best CT</label>
                            <span>{utilFunctions.formatCycleTimes(props.data.operation.bestCT)}</span>
                        </Grid>
                        <Grid item xs={12} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                            <label>Performance</label>
                            <span>{props.data.operation.performance}%</span>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

const PotentialStudyReportSummery = props => {
    return (
        <React.Fragment>
            <Grid container>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.summaryInfoContainer}>
                    <Grid
                        container
                        item
                        xs={6}
                        sm={6}
                        direction="column"
                        alignItems="flex-start"
                        justify="center"
                        className={reportsCommonStyles.summaryInfoGroup}
                    >
                        <Typography>Total Elapsed Time</Typography>
                        <div>{props.data.totalElapsedTime.min}<sub>MIN</sub> {props.data.totalElapsedTime.sec}<sub>SEC</sub></div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={6}
                        sm={6}
                        direction="column"
                        alignItems="flex-start"
                        justify="center"
                        className={reportsCommonStyles.summaryInfoGroup}
                    >
                        <Typography>Total Study PCS</Typography>
                        <div>{props.data.totalStudyPcs}<sub>PCS</sub></div>
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.infoContainer}>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>EPF</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.epf}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>VIDEO MODE</Grid>
                        <Grid item xs={8} className="uppercase bold">
                            {!props.data.isVideoOn ?
                                <img src={videoModeOffColor} /> :
                                <img src={videoModeOffGray} />}
                            {props.data.isVideoOn ?
                                <img src={videoModeOnColor} /> :
                                <img src={videoModeOnGray} />}
                        </Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>TM NAME</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.teamMemberName}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>OPERATION MODE</Grid>
                        <Grid item xs={8} className="uppercase bold">
                            {!props.data.isMultiple ?
                                <img src={singleOperationOn} /> :
                                <img src={singleOperationOff} />}
                            {props.data.isMultiple ?
                                <img src={multipleOperationOn} /> :
                                <img src={multipleOperationOff} />}
                        </Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>CREATED AT</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.createdAt}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>OPERATION</Grid>
                        <Grid item xs={8} className="uppercase bold">SUMMERY</Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={styles.border}>
                    <Grid item xs={4} sm={4} className={styles.topMarginFix}>
                        <GsdActualBarChart gsd={props.data.summery.gsd} actual={props.data.summery.actual} width='100%' height={220} />
                    </Grid>
                    <Grid item xs={8} sm={8} className={styles.topMarginFix}>
                        <OperationTimeSummeryBarChart data={props.data.summery.operationTimesChart || {}} width='100%' height={220} />
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={6} lg={6}>
                    <Grid container item xs={9} className={styles.border}>
                        <Grid container item xs={12}>
                            <Grid item xs={6} className={styles.infoGroup}>
                                {props.data.summery.pcs} <sub>PCS</sub>
                            </Grid>
                            <Grid item xs={6} className={styles.infoGroup}>
                                {utilFunctions.formatCycleTimes(props.data.summery.avgCT)} <sub>AVG</sub>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <PcsLineChart data={props.data.summery.pcsLineChart || {}} width='100%' height={200} />
                        </Grid>
                    </Grid>
                    <Grid container item xs={3}>
                        <Grid item xs={12} className={reportsCommonStyles.dataContainer} >
                            <label>Best CT</label>
                            <span>{utilFunctions.formatCycleTimes(props.data.summery.bestCT)}</span>
                        </Grid>
                        <Grid item xs={12} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                            <label>Performance</label>
                            <span>{props.data.summery.performance}%</span>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

const PotentialStudyReport = (props) => {
    const activeTabAlter = props.reportData.isMultiple ? 1 : 0;
    const [activeTab, setActiveTab] = React.useState(0);
    const onTabsChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setActiveTab(newValue)
    }
    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`mat-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={0} width="100%">
                        {value === index && children}
                    </Box>
                )}
            </div>
        );
    }

    return (
        <React.Fragment>
            <DialogContent>
                <Tabs value={activeTab} onChange={onTabsChange} className="appTabGroup">
                    {props.reportData.isMultiple && <Tab key={0} label={`Summery`} tabIndex={0} />}
                    {!!props.reportData.operations && props.reportData.operations.map((operation, index) => {
                        return (
                            <Tab key={index + activeTabAlter} label={operation.name} tabIndex={index + activeTabAlter} />
                        )
                    })}
                </Tabs>
                {props.reportData.isMultiple && <TabPanel key={0} value={activeTab} index={0} ><PotentialStudyReportSummery data={props.reportData} /></TabPanel>}
                {!!props.reportData.operations && props.reportData.operations.map((operation, index) => {
                    const reportData = {
                        epf: props.reportData.epf,
                        createdAt: props.reportData.createdAt,
                        isMultiple: props.reportData.isMultiple,
                        isVideoOn: props.reportData.isVideoOn,
                        teamMemberName: props.reportData.teamMemberName,
                        totalElapsedTime: props.reportData.totalElapsedTime,
                        totalStudyPcs: props.reportData.totalStudyPcs,
                        operation: operation
                    }
                    return (
                        <TabPanel key={index + activeTabAlter} value={activeTab} index={index + activeTabAlter} >
                            <PotentialStudyReportTab data={reportData} />
                        </TabPanel>
                    )
                })}
            </DialogContent>
            <DialogActions className="isPrintViewHidden">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => window.print()}
                // onClick={onPrint}
                >
                    <PrintIcon /> Print Report
                </Button>
            </DialogActions>
        </React.Fragment>
    )
}

PotentialStudyReport.propTypes = {
    reportData: PropTypes.object.isRequired,
}
PotentialStudyReport.defaultProps = {
    reportData: {
        operations: []
    }
}
export default PotentialStudyReport;

